import {normalizeText} from '../normalizeText';

// Un nombre corto contenido en otro no avisa: «Resumen» está en medio catálogo y no es ambiguo.
const MIN_CONTAINED_LENGTH = 8;

function sameScope(prompt, isAllClients, clientId) {
    if (isAllClients) return !prompt.client;
    if (clientId === null || clientId === undefined || clientId === '') return false;
    return Boolean(prompt.client) && String(prompt.client.id) === String(clientId);
}

/**
 * Un prompt del MISMO alcance con un nombre que la IA puede confundir con el que se está escribiendo:
 * igual una vez normalizado (sin acentos, mayúsculas ni signos), o uno contenido en el otro cuando el
 * más corto tiene al menos 8 caracteres. Avisa, no bloquea: la IA pregunta cuál.
 *
 * `excludeId` es el prompt que se está editando, que no puede parecerse a sí mismo.
 */
export function findSimilarTitle(title, {isAllClients, clientId, excludeId = null}, prompts) {
    const mine = normalizeText(title);
    if (!mine) return null;
    for (const prompt of prompts || []) {
        if (excludeId !== null && prompt.id === excludeId) continue;
        if (!sameScope(prompt, isAllClients, clientId)) continue;
        const other = normalizeText(prompt.title);
        if (!other) continue;
        if (other === mine) return prompt;
        const [shorter, longer] = mine.length <= other.length ? [mine, other] : [other, mine];
        if (shorter.length >= MIN_CONTAINED_LENGTH && longer.includes(shorter)) return prompt;
    }
    return null;
}
